import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import {
	setIsOpenUserProfile,
	setMethodCancel,
	setMethodSuccess,
} from 'store/user-service/userSlice';

import { PaymentStatus } from 'core/enums/common';

export const UpdateMethodResult = ({ status }: { status: PaymentStatus }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		if (status === PaymentStatus.success) {
			dispatch(setMethodSuccess());
		}

		if (status === PaymentStatus.cancel) {
			dispatch(setMethodCancel());
		}

		if (searchParams.get('isProfile')) {
			dispatch(setIsOpenUserProfile(true));
		}
		navigate('/');
	}, []);

	return <></>;
};
